import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";
import { indianCurrencyFormater } from "../../../../helpers/functions/currencyFormater";

const formatLegalDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "short" });

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const ordinal = getOrdinalSuffix(day);
  return `${day}${ordinal} ${month} ${year}`; // Example: 11th May 2025
};

const DPNDocumentPDF = ({ formData }) => {
  const styles = StyleSheet.create({
    page: {
      fontSize: 11,
      padding: 50,
      fontFamily: "Times-Roman",
      paddingTop: 40,
      paddingBottom: 100,
      paddingHorizontal: 40,
      lineHeight: 1.5,
      minHeight: "100vh",
    },
    section: {
      flexGrow: 1,
      paddingHorizontal: 50,
    },
    heading: {
      color: "black",
      fontWeight: "bold",
      textDecoration: "underline",
      textAlign: "center",
    },
    bold: {
      fontWeight: "bold",
      fontSize: 12,
      fontFamily: "Times-Bold",
    },
  });

  function formatCurrencyText(input) {
    return input
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize each word
      .replace(/\bLakh\b/, "Lakhs"); // Optionally convert "Lakh" to "Lakhs"
  }

  const formattedValue = formatCurrencyText(formData?.amount_in_word);

  const formattedAmount = formData.creditLimit.toLocaleString("en-IN");


  const heading = "DEMAND PROMISSORY NOTE";
  const date = formData?.date || "";
  const { day, ordinal, month, year } = formatLegalDate(date);
  const formatedTodaysDate = formatDateDDMMYYYY(date);
  const superfixDate = formatLegalDate(date);
  const amountInWord = formattedValue;
  const PanNo = formData?.pan_no.toUpperCase() || "";
  const address = formData?.address || "";

  const personName = formData?.personName || "";
  const companyName = formData?.companyName || "";
  const dealerName = formData?.dealerName !== undefined && formData?.dealerName !== '' ? formData?.dealerName : (formData?.personName || "");
  const creditLimit = formattedAmount;
  const isTAFundingByMT = formData?.is_ta_funding_by_mt;
  const companyDisplayName = isTAFundingByMT 
    ? "Krishak Sevita Online Solutions Private Limited (KSOS)" 
    : "Tyger Capital Pvt. Limited ( Formerly known as  Adani Capital Pvt Ltd)";
  
    const companyAddress = isTAFundingByMT 
    ? "Global Square,Sr No. 247+14B, 6th Floor, Off No.607&608, Deccan College Road, Yerwada, Pune-411006, Maharashtra, India"
    : "Adani House, 56, Shrimali Society, Navrangpura, Ahmedabad 380009, Gujarat and Corporate Office at 1004/5, 10th Floor, C-Wing, OneBKC, C-66, G-Block, Bandra Kurla Complex, Bandra (East), Mumbai 400051";

  const introductionText = `\nThis demand promissory note is made on date ${superfixDate} (hereinafter referred to as the “Demand Promissory Note”) at Ahmedabad for an amount of Rs. ${creditLimit}/- (${amountInWord} only).\n\n`;

  const content = `   $$$  `;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.heading}>{heading}</Text>

          {/* <Text>{introductionText}</Text> */}
          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Text style={[styles.paragraph, { flex: 1 }]}>
              {`\nThis demand promissory note is made on date `}
              <Text style={[styles.bold, { marginBottom: "5rem" }]}>
                {superfixDate}
              </Text>
              {`  (hereinafter referred to as the “Demand Promissory Note”) at ${isTAFundingByMT ? "Pune" : "Ahmedabad"} for an amount of Rs.  `}
              <Text style={[styles.bold, { marginBottom: "5rem" }]}>
                {creditLimit}
              </Text>
              {` /- ( `}
              <Text style={[styles.bold, { marginBottom: "0rem" }]}>
                {amountInWord}
              </Text>
              {` ).\n\n`}
            </Text>
          </View>

          <View style={{ flexDirection: "row", marginTop: 10 }}>
            {formData?.businessType === "individual" ? (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                {`ON DEMAND`}
                {`,
I `}
                <Text style={styles.bold}>{dealerName}</Text>
                {`,  (PAN No.:`}
                <Text style={styles.bold}>{PanNo}</Text>
                {`) a company having its registered office at `}
                <Text style={styles.bold}>{address}</Text>
                {` India (hereinafter referred to as the "Promisor", which expression shall, unless repugnant to the context or meaning thereof, deem to include its successors and permitted assigns) hereby agree unconditionally to pay `}
                <Text style={styles.bold}>{companyDisplayName}</Text>
                {`, a company incorporated under the Companies Act, 2013 and registered as a non-banking finance company with the Reserve Bank of India, and having its registered office at ${companyAddress} (hereinafter referred to as the "Company", which expression shall, unless repugnant to the context or meaning thereof, deemed to include its successors and assigns), the sum of Rs.`}
                <Text
                  style={styles.bold}
                >{` ${creditLimit}/- (${amountInWord} ) `}</Text>
                {` availed from the Company by Promisor’s subsidiary – Mr.`}
                <Text style={styles.bold}>{`${dealerName}`}</Text>
                {`  (the “Borrower”) with interest from the date hereof, at the applicable interest rate and other amounts payable to the Company as set out in the facility letter dated `}
                <Text style={styles.bold}>{`${superfixDate}`}</Text>
                {`  exchanged between the Borrower and the Company (the “Facility Letter”).
The Promisor hereby unconditionally and irrevocably waives presentment, notice of non - payment, protest and notice of protest, and agrees to remain fully bound notwithstanding the extension or modification of terms or discharge of any collateral for this note and/or in connection with the Facility Letter.
Capitalized terms used but not defined in this Demand Promissory Note shall have the meaning ascribed to them under the Facility Letter. `}
              </Text>
            ) : (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                {`ON DEMAND`}
                {`,
We, M/S `}
                <Text style={styles.bold}>{companyName}</Text>
                {formData?.businessType !== "partnership" && (
                  <Text style={styles.bold}>{` (Prop: ${dealerName})`}</Text>
                )}
                {` (PAN No.:`}
                <Text style={styles.bold}>{PanNo}</Text>
                {`) a company having its registered office at `}
                <Text style={styles.bold}>{address.replace(/,\s*/g, ", ")}</Text>
                {` India (hereinafter referred to as the "Promisor", which expression shall, unless repugnant to the context or meaning thereof, deem to include its successors and permitted assigns) hereby agree unconditionally to pay `}
                <Text style={styles.bold}>{companyDisplayName}</Text>
                {`, a company incorporated under the Companies Act, 2013 and registered as a non-banking finance company with the Reserve Bank of India, and having its registered office at ${companyAddress} (hereinafter referred to as the "Company", which expression shall, unless repugnant to the context or meaning thereof, deemed to include its successors and assigns), the sum of Rs.`}
                <Text
                  style={styles.bold}
                >{` ${creditLimit}/- (${amountInWord} ) `}</Text>
                {` availed from the Company by Promisor’s subsidiary – M/S`}
                <Text style={styles.bold}>{companyName}</Text>
                {formData?.businessType !== "partnership" && (
                  <Text style={styles.bold}>{`(Prop: ${dealerName})`}</Text>
                )}
                {` (the “Borrower”) with interest from the date hereof, at the applicable interest rate and other amounts payable to the Company as set out in the facility letter dated `}
                <Text style={styles.bold}>{`${superfixDate}`}</Text>
                {`  exchanged between the Borrower and the Company (the “Facility Letter”).
The Promisor hereby unconditionally and irrevocably waives presentment, notice of non - payment, protest and notice of protest, and agrees to remain fully bound notwithstanding the extension or modification of terms or discharge of any collateral for this note and/or in connection with the Facility Letter.
Capitalized terms used but not defined in this Demand Promissory Note shall have the meaning ascribed to them under the Facility Letter. `}
              </Text>
            )}
          </View>

          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Text style={styles.bold}>For, </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            {formData?.businessType === "proprietor" ? (
              <>
                <Text style={styles.bold}>{companyName}</Text>
                {formData?.businessType !== "partnership" && (
                  <Text style={styles.bold}> (Prop: {dealerName})</Text>
                )}
              </>
            ) : (
              <Text style={styles.bold}>{dealerName}</Text>
            )}
          </View>
          <View style={{ flexDirection: "row", marginTop: 20 }}>
            <Text style={[styles.paragraph, { marginTop: 80 }]}>
              Authorized Signatory
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default DPNDocumentPDF;
